import { NavigateFunction } from 'react-router-dom';
import { IAutoprospectionError, IMaintenanceError } from 'core/model/interfaces/error.interface';

export class LayoutErrorsUtils {
  private static instance: LayoutErrorsUtils | null = null;
  private navigateFn: NavigateFunction | null = null;
  private maintenanceError: IMaintenanceError['error'] | null = null;
  private autoprospectionError: IAutoprospectionError['error'] | null = null;

  private constructor() {}

  public static getInstance(): LayoutErrorsUtils {
    LayoutErrorsUtils.instance ??= new LayoutErrorsUtils();
    return LayoutErrorsUtils.instance;
  }

  public setNavigate(navigate: NavigateFunction): void {
    this.navigateFn = navigate;
  }

  public getNavigate(): NavigateFunction | null {
    return this.navigateFn;
  }

  public setMaintenanceError(error: IMaintenanceError['error'] | null): void {
    this.maintenanceError = error;
  }

  public getMaintenanceError(): IMaintenanceError['error'] | null {
    return this.maintenanceError;
  }

  public setAutoprospectionError(error: IAutoprospectionError['error'] | null): void {
    this.autoprospectionError = error;
  }

  public getAutoprospectionError(): IAutoprospectionError['error'] | null {
    return this.autoprospectionError;
  }
}

export const setNavigate = (navigate: NavigateFunction) => {
  LayoutErrorsUtils.getInstance().setNavigate(navigate);
};

export const getNavigate = () => LayoutErrorsUtils.getInstance().getNavigate();

export const setMaintenanceError = (error: IMaintenanceError['error'] | null) => {
  LayoutErrorsUtils.getInstance().setMaintenanceError(error);
};

export const getMaintenanceError = () => LayoutErrorsUtils.getInstance().getMaintenanceError();

export const setAutoprospectionError = (error: IAutoprospectionError['error'] | null) => {
  LayoutErrorsUtils.getInstance().setAutoprospectionError(error);
};

export const getAutoprospectionError = () => LayoutErrorsUtils.getInstance().getAutoprospectionError();

export default LayoutErrorsUtils;
